import React from 'react';
import {
    PanelHeader,
    Div,
    Spinner,
    SplitCol,
    SplitLayout,
    Button, ButtonGroup, NativeSelect, FormItem, PanelHeaderButton
} from '@vkontakte/vkui';


import {AdaptivityContext, longDateTimeFormat, setQuizStep} from "../assets/constants";

import BaseComponent from "../components/BaseComponent";

import * as constants from "../assets/constants";
import {Icon20UserCheckOutline, Icon20Users3, Icon24BrowserBack} from "@vkontakte/icons";
import moment from "moment/moment";
import BaseApi from "../api/BaseApi";
import SelectObject from "../assets/SelectObject";


class FacingMonitoringStep1 extends BaseComponent {

    state = {
        loading: true,
        currentStatus: this.props.current_doc ? this.props.current_doc.doc_data.status : '',
        currentType: this.props.current_doc ? this.props.current_doc.doc_data.type_ : '',
        labels: {},
        typesLabels: {},
        currentDivision: undefined,
        error_division: '',
        error_type: ''
    }

    constructor(props) {
        super(props);
        this.state.labels = constants.getFacingMonitoringStatuses()
        this.state.typesLabels = constants.getFacingMonitoringTypes()
        this.state.typesLabels[''] = 'Не указан'
        delete this.state.labels['']
        if (this.props.current_doc && this.props.current_doc.doc_data && this.props.current_doc.doc_data.division_id) {
            const division = {
                name: this.props.current_doc.doc_data.division_name,
                id: this.props.current_doc.doc_data.division_id
            }
            this.state.currentDivision = division

        } /*else if (!this.props.current_doc && this.props.current_user.meta.division && this.props.current_user.meta.division.name) {
            const division = {
                name: this.props.current_user.meta.division.name,
                id: this.props.current_user.meta.division.code
            }
            this.state.currentDivision = division
        }*/
    }


    receiveMessage = (event) => {


    }
    changeCurrentStatus = (status) => {

        if (status == constants.CODE_FACING_MONITORING_STATUS_END && this.props.current_doc.doc_data.status != constants.CODE_FACING_MONITORING_STATUS_IN_PROCESS) {
            window.postMessage({
                type: 'error',
                text: 'Статус "Завершен" можно будет установить только после статуса "В работе"'
            })
            return
        }
        this.setState({currentStatus: status})
        BaseApi.post('?app=facingMonitoring&act=setStatus', {doc_id: this.props.current_doc.doc_data.id, status})
    }
    changeCurrentType = (type) => {


        this.setState({currentType: type})
        if(type){
            this.setState({error_type: ''})
        }
        if (this.props.current_doc && this.props.current_doc.doc_data) {
            BaseApi.post('?app=facingMonitoring&act=setType', {
                doc_id: this.props.current_doc.doc_data.id,
                type
            }).then(() => {
                window.postMessage({type: 'facingMonitoringTypeChanged', newType: type})
            })
        } else {
            localStorage.setItem(constants.current_facing_monitoring_type_key, type)
        }
    }

    selectDivision = (obj) => {

        const currentDivision = {
            name: obj.title,
            id: obj.external_id
        }

        this.setState({currentDivision})
        if(obj){
            this.setState({error_division: ''})
        }
        if (this.props.current_doc && this.props.current_doc.doc_data) {
            BaseApi.post('?app=facingMonitoring&act=setDivision',
                {
                    doc_id: this.props.current_doc.doc_data.id,
                    division_id: obj.external_id,
                    division_name: obj.title,
                }).then(() => {
                window.postMessage({type: 'facingMonitoringDivisionChanged', newDivision: currentDivision})
            })
        } else {
            localStorage.setItem(constants.current_facing_monitoring_division_key, JSON.stringify(currentDivision))
        }

    }

    render() {
        const images_url = this.props.base_url.replace("frontend/", '');
        const is_moder = constants.checkIsModer(this.props.current_user)
        const current_user_id = this.props.current_user ? this.props.current_user.id : null

        return (
            <div>
                <SplitLayout>
                    <SplitCol>
                        <PanelHeader fixed={true}>
                            Инвентаризация витрины. Шаг 1
                        </PanelHeader>
                    </SplitCol>
                </SplitLayout>
                <SplitLayout>
                    <SplitCol>
                        <FormItem top={"Статус"}>
                            <NativeSelect
                                style={{
                                    zIndex: 6,
                                    marginLeft: '10px',
                                    height: '30px',
                                    maxWidth: AdaptivityContext.isMobile && this.props.monitoring_mode ? '150px' : 'inherit'
                                }}
                                disabled={!this.props.current_doc
                                    || this.props.current_doc.doc_data.status == constants.CODE_FACING_MONITORING_STATUS_END
                                    || (this.props.current_doc && this.props.current_doc.doc_data && this.props.current_doc.doc_data.user_id != current_user_id && !is_moder)
                                }
                                value={this.state.currentStatus}
                                onChange={(e) => this.changeCurrentStatus(e.target.value)}
                            >
                                {Object.keys(this.state.labels).map((itemP, indexP) => (
                                    <option value={itemP}>{this.state.labels[itemP]}</option>
                                ))}</NativeSelect>
                        </FormItem>
                    </SplitCol>
                </SplitLayout>

                <SplitLayout>
                    <SplitCol>
                        <FormItem top="Тип инвентаризации"
                                  bottom={this.state.error_type}
                                  status={this.state.error_type ? 'error' : ''}>
                            <NativeSelect

                                style={{
                                    zIndex: 6,

                                    height: '30px',
                                    maxWidth: AdaptivityContext.isMobile && this.props.monitoring_mode ? '150px' : 'inherit'
                                }}
                                disabled={this.props.current_doc && this.props.current_doc.doc_data && this.props.current_doc.doc_data.status == constants.CODE_FACING_MONITORING_STATUS_END}
                                value={this.state.currentType}
                                onChange={(e) => this.changeCurrentType(e.target.value)}
                            >
                                {Object.keys(this.state.typesLabels).map((itemP, indexP) => (
                                    <option value={itemP}>{this.state.typesLabels[itemP]}</option>
                                ))}</NativeSelect>
                        </FormItem>
                    </SplitCol>
                </SplitLayout>
                <SplitLayout>
                    <SplitCol>
                        <SelectObject current_user={this.props.current_user}
                                      title="Подразделение" app="divisions"
                                      act="getListJson"
                                      className={'selectObjectDropdownStyle'}
                                      style={{minHeight: '33px'}}
                                      error={this.state.error_division}
                                      modal_title="Подразделения"
                                      base_url={this.props.base_url}
                                      selectObject={this.selectDivision}
                                      default={this.state.currentDivision}
                                      mode="outline"
                                      size="s"
                        />
                    </SplitCol>
                </SplitLayout>

                <SplitLayout>
                    <SplitCol>
                        <Div className="summary-element">
                            Номер: {this.props.current_doc ? this.props.current_doc.doc_data.nomer : 'Новый'}
                        </Div>
                    </SplitCol>
                </SplitLayout>
                <SplitLayout>
                    <SplitCol>
                        <Div className="summary-element">
                            Дата: {this.props.current_doc ? this.props.current_doc.doc_data.date : moment(new Date()).format('DD.MM.YYYY')}
                        </Div>
                    </SplitCol>
                </SplitLayout>
                {this.props.current_doc && this.props.current_doc.doc_data.comment && <SplitLayout>
                    <SplitCol>
                        <Div className="summary-element">
                            Комментарий: {this.props.current_doc ? this.props.current_doc.doc_data.comment : ''}
                        </Div>
                    </SplitCol>
                </SplitLayout>}
                <SplitLayout>
                    <SplitCol>
                        <Div className="action-board">
                            <ButtonGroup mode="horizontal" stretched>
                                <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                        onClick={() => window.postMessage({type: 'goToFacingMonitoringDocs'})}>Назад</Button>
                                <Button stretched size={AdaptivityContext.isMobile ? 'm' : 'l'}
                                        onClick={() => this.nextStep()}>Далее</Button>
                            </ButtonGroup>
                        </Div>
                    </SplitCol>
                </SplitLayout>
            </div>
        )
    }


    nextStep = () => {

        let error = 0

        this.setState({error_division:'', error_type:''})
        if(!this.state.currentDivision){
            error++
            this.setState({error_division: "Необходимо указаать подразделение!"})
        }
        if(!this.state.currentType){
            error++
            this.setState({error_type: "Необходимо указать тип!"})
        }

        if(error == 0) {
            setQuizStep(2, 'FacingMonitoring')
        }
    }
}

export default FacingMonitoringStep1